import React, { useEffect, useRef, useState } from "react";

/**
 * Renders children only once scrolled near the viewport, reserving space until
 * then. Keeps the feed from mounting (and image-fetching) every AOTD tile at once.
 */
const LazyVisible: React.FC<{ children: React.ReactNode; minHeight?: number }> = ({ children, minHeight = 360 }) => {
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => { if (entries[0]?.isIntersecting) { setShow(true); obs.disconnect(); } },
      { rootMargin: "600px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return <div ref={ref} style={show ? undefined : { minHeight }}>{show ? children : null}</div>;
};

export default LazyVisible;
